import { usePublicWhiteLabel } from '~/components/v2/hooks/useWhiteLabel';
import { useHideAirLogo } from '~/hooks/useHideAirLogo';

/**
 * Whether the public share-link viewer should show Air's logo. Hidden when the publisher set
 * `presentationSettings.hideAirLogo` or when the workspace is white-labeled. Must be called
 * within a `ShortIdProvider`.
 */
export const useShowPublicAirLogo = (): { showAirLogo: boolean } => {
  const { hideAirLogo } = useHideAirLogo();
  const { isWhiteLabel } = usePublicWhiteLabel();

  return { showAirLogo: !hideAirLogo && !isWhiteLabel };
};
